import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var DeletePinCommandClass;
function DeletePinCommand() {
  if (DeletePinCommandClass === VOID) {
    class $ {
      constructor(partyId, pinId) {
        this.w2k_1 = partyId;
        this.x2k_1 = pinId;
      }
      toString() {
        return 'DeletePinCommand(partyId=' + this.w2k_1.toString() + ', pinId=' + this.x2k_1.toString() + ')';
      }
      hashCode() {
        var result = this.w2k_1.hashCode();
        result = imul(result, 31) + this.x2k_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePinCommand()))
          return false;
        if (!this.w2k_1.equals(other.w2k_1))
          return false;
        if (!this.x2k_1.equals(other.x2k_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePinCommand');
    DeletePinCommandClass = $;
  }
  return DeletePinCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatcher2txct93ff9b99,
  DeletePinCommand as DeletePinCommand22e3cscq35h1f,
};
//endregion

//# sourceMappingURL=DeletePinCommand.mjs.map
